export default __webpack_public_path__ + "static/media/html.c28bc668.svg";